import { FishBase } from "./FishBase";

export class PanfishAI extends FishBase {
    constructor(scene: Phaser.Scene, x: number, y: number, species: "Bluegill" | "Crappie" | "Perch", textureKey: string) {
        super(scene, x, y, {
            species,
            textureKey,
            pointValue: 10,
            swimSpeed: 80,
        });
    }
}
